<template>
    <div
        style="display: inline-block;"
        :id="openid"
    >
        <ww-open-data
            :type="type"
            :openid="openid"
        />
    </div>

</template>
<script>
export default {
    props: ["type", "openid", "name"],
    mounted() {
        var _this = this;
        var _ele = this.$el
        WWOpenData.bind(_ele);
        if (WWOpenData.checkSession) {
            WWOpenData.checkSession({
                success() {
                    console.log('企业微信服务有登录态')
                },
                fail() {
                    console.error('企业微信服务登录态过期')
                    _ele.innerHTML = _this.name;
                }
            })
        }
        if (WWOpenData.on) {
            WWOpenData.on("error", () => {
                
                var innerText = ''
                 innerText = _this.name;
                // _ele && (_ele.innerHTML = innerText)
            });
        }
    },
};
</script>
<style lang="scss" scoped>
.depa_nowrap {
    width: 2.9rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>